import { useState, useRef, useEffect } from "react";

export const useAnimatedValue = (startValue, endValue, durationSeconds) => {
  const [value, setValue] = useState(startValue);
  const animationFrame = useRef(null);
  const startTime = useRef(null);

  const start = () => {
    cancelAnimationFrame(animationFrame.current);
    startTime.current = null;

    const step = (timestamp) => {
      if (!startTime.current) startTime.current = timestamp;
      const elapsed = (timestamp - startTime.current) / 1000; // en secondes
      const progress = Math.min(elapsed / durationSeconds, 1);
      const newValue = startValue + (endValue - startValue) * progress;
      setValue(newValue);
      if (progress < 1) {
        animationFrame.current = requestAnimationFrame(step);
      }
    };

    animationFrame.current = requestAnimationFrame(step);
  };

  useEffect(() => {
    return () => cancelAnimationFrame(animationFrame.current);
  }, []);

  return { newScore: value, start };
};
